import {
  updateData,
  updateSupportData,
  updateValidation,
} from '../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_KEY, PENSIONS_CRUD_OVERVIEW } from '../PensionWorkflowConstants';
import { buildMutation } from '../../AdvWorkflow/AdvWorkflowHelpers';

export const onCancel = (workflowId, clientId, isEdit, graphPensions) => (dispatch) => {
  dispatch(updateValidation(buildMutation(`${BACKEND_KEY}.PensionsAddEdit`, []), workflowId, clientId));

  if (!isEdit) {
    dispatch(updateData(
      {
        [BACKEND_KEY]: graphPensions.slice(0, graphPensions.length - 1),
      },
      workflowId,
      clientId,
    ));
  }
  dispatch(updateSupportData(
    {
      [BACKEND_KEY]: {
        PensionStepViewID: PENSIONS_CRUD_OVERVIEW,
      },
    },
    workflowId,
    clientId,
  ));
};

export default onCancel;
